<template>
  <div class="">
    <div class="d-flex justify-content-between">
      <div>
        <a class="text-decoration-none" href="javascript:void(0)"
        ><span class="see-more-link text-decoration-none">{{ title }}</span></a
        >
      </div>
    </div>
    <m-products-wrapper :dirty-router-after-page-change="false" :product-brands="productBrands"
                        :product-categories="productCategories">
      <template slot-scope="{products,pagination,changePageFunction}">
        <swiper v-if="products.length > 0" ref="mySwiper" :options="swiperOptions">

          <swiper-slide v-for="product in products" :key="product.id" v-if="ignoreProduct.indexOf(product.id) === -1">
            <m-c301 :product="product"
                    :digitalShoppingCartBadge="digitalShoppingCartBadge"
                    :physicalShoppingCartBadge="physicalShoppingCartBadge"
            />
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </template>
    </m-products-wrapper>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {Swiper, SwiperSlide, directive} from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "RelatedProducts-301",
  props: {
    title: {
      type: String,
      default: "محصولات مرتبط"
    },
    digitalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    physicalShoppingCartBadge: {
      default: 'مشاهده و خرید',
    },
    productBrands: {
      default: null
    },
    productCategories: {
      default: null
    },
    ignoreProduct: {
      default: () => {
        return []
      }
    },
  },
  components: {Swiper, SwiperSlide, directive},
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
          },
          500: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          765: {
            slidesPerView: 3,
          },
          980: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          }
        }
      },
    };
  },
}
</script>

<style scoped>
.slider-row {
  padding-top: 20px;
  margin-left: 30px;
  margin-right: 30px;
}

.slider-controls {
  border-bottom: 1px solid #c4c4c4;
}
</style>